import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Divider from '@material-ui/core/Divider'
import ReactPaginate from 'react-paginate'
import { formatDateAndTime } from '../../utils/dashboard.utils'
import { Translation } from 'react-i18next'
import mobileView from '../../utils/mobile.utils'
import ReleaseInfoMobileComponent from './releaseInfoMobile.component'

class ReleaseInfoComponent extends React.Component {
  render() {
    return <ReleaseInfo {...this.props} />
  }
}

const styles = () => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  table: {
    minWidth: 700
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black'
  },
  tablecell1: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: 'black'
  }
})

const ReleaseInfo = ({
  releaseInfoSearchRows,
  selected,
  releaseInfoSearchPages,
  releaseInfoSearchPageChange,
  classes
}) => (
  <Translation>
    {(t) => {
      return (
        <div className="panel-body pd-0">
          <div className={classes.root}>
            {mobileView ? (
              <ReleaseInfoMobileComponent
                releaseInfoSearchRows={releaseInfoSearchRows}
                selected={selected}
              />
            ) : (
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tablecell}
                      style={{ width: '25%' }}
                    >
                      {t('dashboardRelaseInfo.julk')}
                    </TableCell>
                    <TableCell
                      className={classes.tablecell}
                      style={{ width: '75%' }}
                    >
                      {t('dashboardRelaseInfo.julk2')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {createReleaseInfoRow(
                    releaseInfoSearchRows,
                    selected,
                    classes
                  )}
                </TableBody>
              </Table>
            )}
            <Divider />
            <ReactPaginate
              previousLabel={<i className="fa fa-chevron-left" />}
              nextLabel={<i className="fa fa-chevron-right" />}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={releaseInfoSearchPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={releaseInfoSearchPageChange}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
          </div>
        </div>
      )
    }}
  </Translation>
)

const createReleaseInfoRow = (releaseInfoSearchRows, selected, classes) => {
  return releaseInfoSearchRows
    .slice(selected * 5, selected * 5 + 5)
    .map((el, index) => (
      <TableRow
        key={el.update_id}
        style={index % 2 ? { background: 'white' } : { background: '#ebf9fa' }}
      >
        <TableCell className={classes.tablecell1} style={{ width: '25%' }}>
          {formatDateAndTime(el.created)}
        </TableCell>
        <TableCell
          className={classes.tablecell1}
          style={{ width: '75%', whiteSpace: 'normal', wordWrap: 'break-word' }}
        >
          <span>{el.newsupdate}</span>
        </TableCell>
      </TableRow>
    ))
}

ReleaseInfoComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ReleaseInfoComponent)
